import React, { useState, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import { getPosts } from 'Redux/ducks/blog';
import BlogPagination from 'Components/Utility/BlogPagination';
import BlogBreadcrumbs from 'Components/Utility/SEO/BlogBreadcrumbs';
import BlogPostsPage from 'Components/Blog/BlogPostsPage';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';
import BlogHomePageHeader from 'Components/Blog/BlogHomePageHeader';
import BlogSearch from 'Components/Blog/BlogSearch';
import BlogCategories from 'Components/Blog/BlogCategories';
import { getAuthorBySlug } from 'Components/Blog/content/AuthorData';
import NotFound from 'Components/NotFound/NotFound';


const BlogPostsContainer = ({ match }) => {
  const [postsObj, setPostsObj] = useState({});
  const search = getUrlParameter('search') || '';
  const page = getUrlParameter('page') || 1;
  const tag = getUrlParameter('tag') || '';
  const category = get(match, 'params.category');
  const authorSlug = get(match, 'params.authorSlug');
  let authorName;
  let guestAuthorName;
  const authorData = getAuthorBySlug(authorSlug);
  let invalidAuthor = false;

  if (authorSlug) {
    if (!authorData) invalidAuthor = true;
    if (authorData && !authorData.isGuest) authorName = authorData.name;
    if (authorData && authorData.isGuest) guestAuthorName = authorData.name;
  }

  useEffect(() => {
    const loadPosts = async () => {
      const fetchedPostsObj = await getPosts({
        pageSize: 14,
        page: Number(page),
        tag,
        searchTerm: search,
        category,
        authorName,
        guestAuthorName,
      });
      return setPostsObj(fetchedPostsObj);
    };

    loadPosts();
  }, [page, tag, search, category, authorName, guestAuthorName]);

  if (!postsObj) return false;

  let noResults = false;
  if (isEmpty(postsObj.results)) {
    noResults = true;
  }

  if (!postsObj.page) {
    return true;
  }

  if (invalidAuthor) {
    return <NotFound />;
  }

  return (
    <main className="fanatical-blog">
      <BlogBreadcrumbs category={category} tag={tag} />
      <BlogHomePageHeader />
      <BlogCategories category={category} />
      <BlogSearch value={search} />
      <BlogPostsPage
        posts={postsObj.results}
        tagged={tag}
        search={search}
        category={category}
        page={postsObj.page || 1}
        totalResultsSize={postsObj.total_results_size}
        authorSlug={authorSlug}
      />
      <BlogPagination
        page={(postsObj.page - 1) || 0}
        nbPages={postsObj.total_pages}
        category={category}
        authorSlug={authorSlug}
        tag={tag}
        search={search}
        noResults={noResults}
      />
    </main>
  );
};

BlogPostsContainer.propTypes = {
  match: PropTypes.shape({}).isRequired,
};


export default BlogPostsContainer;
